import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const TestFlight: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <h1>
        <a href='https://help.apple.com/app-store-connect/#/devdc42b26b8'>
          TestFlight
        </a>
      </h1>
      <p className='text-justify'>
        Para poder distribuir las entregas parciales de una aplicación IOS
        usamos Test Flight, la plataforma oficial de Apple para poder ofrecer
        versionas beta de tu aplicación a distintos usuarios. Lo más importante
        a saber es que existen dos formas de ofrecer beta testing de una
        aplicación en Test Flight
      </p>
      <h2>Testeo interno</h2>
      <p className='text-justify'>
        En Test Flight podes distribuir una aplicación para hacer testeo
        interno. En ese caso apple da un límite de <strong>100 testers</strong>,
        y les da acceso a cualquier build de la aplicación que hayas subido al
        AppStore Connect. Una de las cosas buenas que tiene es que permite
        saltearse la revisión de Apple, y entrega la aplicación más o menos
        inmediatamente.{" "}
        <strong>
          No se debería usar este método de entrega de betas con clientes
        </strong>
        , está bueno tener esa instancia extra de revisión de apple para
        chequear que lo que estamos haciendo se va a poder publicar, y no
        requiere que tengamos que agregar a cada tester del cliente como usuario
        interno del proyecto en apple. Para el cliente es mucho más comodo tener
        un link al que puede entrar e instalar la aplicación que puede compartir
        con cualquiera, antes de tener que hacer todo el proceso de entrar en el
        equipo interno. Además de que limita los testers a 100 personas, y
        varias veces el usuario puede querer empezar a compartirlo a conocidos y
        personas dentro de la organización.{" "}
        <strong>
          Es buena idea usar esta forma de entrega para personas dentro del
          equipo de desarrollo
        </strong>{" "}
        (desarrolladores de back-end, proyect manager, desarrolladores mobile,
        etc.)
      </p>
      <h2>Testeo externo</h2>
      <p className='text-justify'>
        Para hacer testeo "masivo" y permitir a personas externas al equipo de
        desarrollo probar las versiones, TestFlight ofrece la posibilidad de
        habilitar determinados builds subidos a AppStore Connect para testers
        externos, estos pueden ser agregados a mano sin mucho problema, estar
        separados en equipos, o incluso se puede dar un link para que cualquiera
        pueda entrar e instalarse la aplicación casi sin complicaciones, para el
        tester es muy comodo y permite a los desarrolladores tener mayor control
        sobre que versión tiene instalada cada tester.{" "}
        <strong>
          En el caso del testeo externo Apple tiene que aprobar el compilado
          antes de poder habilitarlo
        </strong>{" "}
        No suele ser algo que demore mucho, y es hasta benificioso para tener
        una instancia de testeo extra que de paso nos diga si no estamos
        rompiendo ninguna regla del AppleStore
      </p>
    </Container>
  );
};

export default new Content({
  Component: TestFlight,
  title: "TestFlight",
  route: "test-flight",
  tags: ["ios", "test", "mobile", "apple"]
});
